<template>
  <div>
    <!--顶部按钮-->
    <div class="app-container">
      <div style="margin-bottom: 10px">
        <div style="display: flex; justify-content: space-between; align-items: center">
          <div>
            <vxe-button @click="addFun" status="primary">新增</vxe-button>
            <vxe-button @click="exportMaterialApplyQuotaList" status="primary">导出</vxe-button>
            <vxe-button @click="showImportDialog" status="primary">导入</vxe-button>
            <vxe-button @click="exportDeptList" status="primary">导出部门信息</vxe-button>
          </div>
          <div style="display: flex; align-items: center">
            <a-date-picker
              v-model="queryCondition.applyYear"
              mode="year"
              placeholder="年份"
              style="width: 120px; margin-right: 1rem"
              format="YYYY"
              :open="yearPickerOpen"
              @openChange="handleYearOpenChange"
              @panelChange="handleYearChange"
            />
            <DeptTreeSelect
              v-model="selectedDeptValues"
              :multiple="true"
              placeholder="部门"
              style="width: 200px; margin-right: 1rem"
              @change="handleDeptFilterChange"
              @deptIdsChange="handleDeptIdsChange"
            />
            <vxe-button status="primary" @click="queryByPage(1)">搜索</vxe-button>
            <vxe-button class="filter-search-item" @click="resetForm">重置</vxe-button>
          </div>
        </div>
      </div>
      <!--table列表-->
      <vxe-table
        ref="xTable"
        :loading="listLoading"
        :align="allAlign"
        :max-height="$store.state.app.height - 130 < 500 ? 500 : $store.state.app.height - 130"
        border
        show-header-overflow
        show-overflow
        class="mytable-scrollbar"
        :column-config="{ resizable: true }"
        stripe
        round
        :scroll-y="{ enabled: false }"
        :row-config="{ isHover: true }"
        :data="tableData"
      >
        <vxe-column type="checkbox" width="60" align="center" />
        <vxe-column type="seq" title="序号" width="80" align="center" />
        <vxe-column field="applyYear" title="年份" min-width="120" align="center" />
        <vxe-column field="deptId" title="部门ID" min-width="100" align="center" />
        <vxe-column field="deptName" title="部门名称" min-width="200" align="center" />
        <vxe-column field="applyQuota" title="申请额度（元）" min-width="150" align="center" />
        <vxe-column field="remainQuota" title="剩余额度（元）" min-width="150" align="center" />
        <vxe-column field="remark" title="备注" min-width="200" align="center" />
        <vxe-column title="操作" width="250" fixed="right" align="center">
          <template #default="{ row }">
            <div class="operate">
              <a-button size="small" type="link" status="primary"  @click="viewFun(row)">查看</a-button>
              <a-button size="small" type="link" status="primary"  @click="editFun(row)">修改</a-button>
              <a-button size="small" type="link" status="primary"  @click="deleteFun(row)">删除</a-button>
            </div>
          </template>
        </vxe-column>
      </vxe-table>
      <vxe-pager
        :current-page="pagination.current"
        :page-size="pagination.size"
        :total="pagination.total"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="changePage"
      />
    </div>

    <!-- 新增/修改/查看对话框 -->
    <a-modal
      :title="dialogTitle"
      v-model="dialogVisible"
      width="500px"
      @ok="submitForm"
      @cancel="cancelForm"
    >
      <a-form-model
        ref="quotaForm"
        :model="formData"
        :rules="formRules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="年份" prop="applyYear">
          <a-date-picker
            v-model="formData.applyYear"
            mode="year"
            :disabled="isView"
            placeholder="请选择年份"
            style="width: 100%"
            format="YYYY"
            :open="formYearPickerOpen"
            @openChange="handleFormYearOpenChange"
            @panelChange="handleFormYearChange"
          />
        </a-form-model-item>
        <a-form-model-item label="部门" prop="dealerId">
          <DeptTreeSelect
            v-model="selectedDeptValue"
            :multiple="false"
            :disabled="isView"
            placeholder="请选择部门"
            @change="handleDeptFormChange"
          />
        </a-form-model-item>
        <a-form-model-item label="申请额度（元）" prop="applyQuota">
          <a-input-number
            v-model="formData.applyQuota"
            :min="0"
            :precision="2"
            :disabled="isView"
            placeholder="请输入申请额度"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-textarea
            v-model="formData.remark"
            :disabled="isView"
            placeholder="请输入备注"
            :rows="4"
          />
        </a-form-model-item>
      </a-form-model>
      <span slot="footer" class="dialog-footer" v-if="!isView">
        <vxe-button size="small" @click="cancelForm">取 消</vxe-button>
        <vxe-button size="small" status="primary" @click="submitForm">确 定</vxe-button>
      </span>
      <span slot="footer" class="dialog-footer" v-else>
        <vxe-button size="small" @click="cancelForm">关 闭</vxe-button>
      </span>
    </a-modal>

    <!-- 导入对话框 -->
    <a-modal title="导入Excel" v-model="importDialogVisible" width="400px" :footer="null" @cancel="onUploadCancel">
      <div :loading="importLoading" class="faultAdd">
        <div class="model-box">
          <a class="load-buttom" @click="downloadTemplate"><i class="el-icon-download" />下载示例模板</a>
        </div>

        <el-upload
          ref="upload"
          class="upload-demo"
          drag
          action=""
          multiple
          :http-request="upload"
          :before-upload="uploadBefore"
          :file-list="fileList"
        >
          <i class="el-icon-upload" />
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div slot="tip" class="el-upload__tip">直接导入已填好的Excel列表，仅支持XLS/XLSX</div>
        </el-upload>
        <div v-if="errorList.length>0" class="err-box">
          <a-button type="link" danger>Excel导入出错，请检查错误行，然后将错误行重新导入</a-button>
          <div v-for="item in errorList" :key="item.row">
            <a-button type="link">第{{ item.row }}行{{ item.error }}</a-button>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {
  findMaterialApplyQuotaList,
  getMaterialApplyQuotaById,
  addMaterialApplyQuota,
  updateMaterialApplyQuota,
  deleteMaterialApplyQuota,
  downloadMaterialApplyQuotaTemplate,
  importMaterialApplyQuota,
  exportMaterialApplyQuotaList
} from '@/api/material'
import { dataApi } from '@/services/comm/memberManage'
import { XEUtils } from '@/utils/common/FormBase'
import DeptTreeSelect from './components/DeptTreeSelect.vue'
import moment from 'moment'

const defaultPagination = {
  total: 0,
  size: 20,
  current: 1
}

export default {
  name: 'MaterialApplyQuota',
  components: {
    DeptTreeSelect
  },
  data() {
    return {
      pagination: Object.assign({}, defaultPagination),
      listLoading: false,
      tableData: [],
      allAlign: 'center',
      queryCondition: {},
      dialogVisible: false,
      dialogTitle: '新增',
      isView: false,
      formData: {
        id: null,
        applyYear: null,
        deptId: null,
        deptName: null,
        applyQuota: null,
        remainQuota: null,
        remark: ''
      },
      formRules: {
        applyYear: [
          { required: true, message: '请输入年份', trigger: 'blur' }
        ],
        deptId: [
          { required: true, message: '请选择部门', trigger: 'change' }
        ],
        applyQuota: [
          { required: true, message: '请输入申请额度', trigger: 'blur' }
        ]
      },
      importDialogVisible: false,
      importLoading: false,
      fileList: [],
      errorList: [],
      // 部门选择器
      deptSelectorVisible: false,
      isDeptFilter: false,
      selectedDepts: [],
      deptDisplayText: '',
      // 树选择器
      selectedDeptValues: [],
      selectedDeptValue: null,
      // 选中的部门ID列表（包括子部门）
      selectedDeptIds: [],
      // 年份选择器
      yearPickerOpen: false,
      formYearPickerOpen: false,
      // 部门树数据
      deptList: [],
      allDeptList: []
    }
  },
  created() {
    this.getDeptList()
    this.queryByPage()
  },
  activated() {
    this.getDeptList()
    this.queryByPage()
  },
  methods: {
    // 获取部门列表
    async getDeptList() {
      try {
        const res = await dataApi.getDeptList()
        if (res.code === 200 && res.data) {
          this.allDeptList = res.data
          // 构建树形结构（用于显示，如果需要的话）
          this.deptList = XEUtils.toArrayTree(res.data, {
            key: 'deptId',
            parentKey: 'parentId',
            children: 'children'
          })
        }
      } catch (error) {
        console.error('获取部门列表失败:', error)
      }
    },
    // 分页
    changePage({ currentPage, pageSize }) {
      this.pagination.current = currentPage
      if (pageSize != this.pagination.size) this.pagination.current = 1
      this.pagination.size = pageSize
      this.queryByPage()
    },
    // 重置筛选
    resetForm() {
      this.queryCondition = {
        applyYear: null
      }
      this.selectedDepts = []
      this.selectedDeptValues = []
      this.selectedDeptIds = []
      this.deptDisplayText = ''
      this.queryByPage(1)
    },
    // 搜索表格数据
    async queryByPage(e) {
      if (e) this.pagination.current = e
      this.listLoading = true
      const queryData = {
        page: this.pagination.current,
        limit: this.pagination.size,
        applyYear: this.queryCondition.applyYear ? this.queryCondition.applyYear.format('YYYY') : null
      }
      // 添加部门筛选条件（使用组件返回的 deptIds）
      if (this.selectedDeptIds.length > 0) {
        queryData.deptIds = this.selectedDeptIds.join(',')
        console.log('查询参数 - deptIds:', queryData.deptIds)
      }
      console.log('查询参数:', queryData)
      findMaterialApplyQuotaList(queryData).then(res => {
        if (res.code === 1 && res.data) {
          this.tableData = res.data.list
          this.pagination.total = res.data.total
          this.listLoading = false
        } else {
          this.$message.error('搜索失败')
          this.listLoading = false
        }
      }).catch(() => {
        this.listLoading = false
      })
    },
    // 新增
    addFun() {
      this.dialogTitle = '新增'
      this.isView = false
      this.formData = {
        id: null,
        applyYear: moment(),
        deptId: null,
        deptName: null,
        applyQuota: null,
        remark: ''
      }
      this.selectedDeptValue = null
      this.dialogVisible = true
    },
    // 查看
    viewFun(row) {
      this.dialogTitle = '查看'
      this.isView = true
      getMaterialApplyQuotaById(row.id).then(res => {
        if (res.code === 1) {
          this.formData = {
            id: res.data.id,
            applyYear: res.data.applyYear ? moment(res.data.applyYear, 'YYYY') : null,
            deptId: res.data.deptId,
            deptName: res.data.deptName,
            applyQuota: res.data.applyQuota,
            remark: res.data.remark || ''
          }
          this.selectedDeptValue = res.data.deptId ? `dept_${res.data.deptId}` : null
          this.dialogVisible = true
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 修改
    editFun(row) {
      this.dialogTitle = '修改'
      this.isView = false
      getMaterialApplyQuotaById(row.id).then(res => {
        if (res.code === 1) {
          this.formData = {
            id: res.data.id,
            applyYear: res.data.applyYear ? moment(res.data.applyYear, 'YYYY') : null,
            deptId: res.data.deptId,
            deptName: res.data.deptName,
            applyQuota: res.data.applyQuota,
            remark: res.data.remark || ''
          }
          this.selectedDeptValue = res.data.deptId ? `dept_${res.data.deptId}` : null
          this.dialogVisible = true
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 删除
    deleteFun(row) {
      const data = { id: row.id }
      this.$confirm({
        title: '提示',
        content: '确定删除该申领额度？',
        onOk: () => {
          deleteMaterialApplyQuota(data).then(res => {
            if (res.code === 1) {
              this.$message.success('删除成功')
              this.queryByPage(1)
            } else {
              this.$message.error(res.message)
            }
          })
        },
        onCancel() {}
      })
    },
    // 提交表单
    submitForm() {
      if (this.isView) {
        this.cancelForm()
        return
      }
      this.$refs.quotaForm.validate(valid => {
        if (valid) {
          const apiMethod = this.formData.id ? updateMaterialApplyQuota : addMaterialApplyQuota
          const submitData = {
            ...this.formData,
            applyYear: this.formData.applyYear ? this.formData.applyYear.format('YYYY') : null
          }
          apiMethod(submitData).then(res => {
            if (res.code === 1) {
              this.$message.success(this.formData.id ? '修改成功' : '新增成功')
              this.dialogVisible = false
              this.queryByPage(1)
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    },
    // 取消表单
    cancelForm() {
      this.dialogVisible = false
      this.$refs.quotaForm.resetFields()
    },
    // 下载模板
    downloadTemplate() {
      downloadMaterialApplyQuotaTemplate().then(res => {
        this.$exportExcelData(res, `物料申领额度导入模板_${new Date().Format('yyyyMMddHHmmss')}.xlsx`)
      }).catch(() => {
        this.$message.error('下载模板失败')
      })
    },
    // 显示导入对话框
    showImportDialog() {
      this.importDialogVisible = true
      this.fileList = []
      this.errorList = []
    },
    // 上传前对文件的大小的判断
    uploadBefore(file) {
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      const size = file.size / 1024 / 1024
      if (extension !== 'xlsx' && extension !== 'xls') {
        this.$message('只能上传后缀是.xlsx或者.xls的文件')
        return false
      }

      if (size > 10) {
        this.$message('文件大小不得超过10M')
        return false
      }
    },
    // 上传
    upload(file) {
      let formData = new FormData()
      formData.append('file', file.file)
      this.importLoading = true
      importMaterialApplyQuota(formData).then(res => {
        this.importLoading = false
        if (res.code === 1) {
          if (res.data == null) {
            this.$message.success('上传成功')
            this.$refs.upload.clearFiles()
            this.importDialogVisible = false
            this.errorList = []
          }
          this.queryByPage()
        } else {
          this.errorList = res.data
          this.$message.error(res.message)
        }
      })
    },
    // 取消上传
    onUploadCancel() {
      this.errorList = []
      this.fileList = []
    },
    // 导出部门信息（纯前端实现）
    async exportDeptList() {
      try {
        this.$message.info('正在导出部门信息...')

        // 获取所有部门数据
        const res = await dataApi.getDeptListWithDealer()
        if (res.code !== 200 || !res.data || res.data.length === 0) {
          this.$message.warning('没有部门数据可导出')
          return
        }

        // 创建部门ID到部门对象的映射
        const deptMap = {}
        res.data.forEach(dept => {
          deptMap[dept.deptId] = dept
        })

        // 指定需要的部门ID列表
        const targetDeptIds = [1392, 1397, 1396, 1395, 5010, 14, 1393, 5049, 1394, 13, 5012, 25]

        console.log('目标部门ID列表:', targetDeptIds)
        console.log('总部门数量:', res.data.length)

        // 检查部门是否是431的子部门（递归向上查找所有层级）
        const isChildOf431 = (deptId) => {
          if (deptId === 431) return false // 431本身不算子部门

          let currentDept = deptMap[deptId]
          while (currentDept && currentDept.parentId) {
            if (currentDept.parentId === 431) {
              return true
            }
            currentDept = deptMap[currentDept.parentId]
          }
          return false
        }

        // 过滤部门数据
        const filteredDepts = res.data.filter(dept => {
          // 1. 如果是指定的部门ID列表中的部门，直接包含
          if (targetDeptIds.includes(dept.deptId)) {
            console.log('匹配到目标部门:', dept.deptId, dept.deptName)
            return true
          }

          // 2. 如果是431的子部门（包括所有层级的子部门），需要满足 isRegion = '1' 或 isDealer = '1'
          if (isChildOf431(dept.deptId)) {
            const isValid = dept.isRegion == '1' || dept.isDealer == '1'
            if (isValid) {
              console.log('匹配到431子部门:', dept.deptId, dept.deptName, 'parentId:', dept.parentId, 'isRegion:', dept.isRegion, 'isDealer:', dept.isDealer)
            } else {
              console.log('431子部门不满足条件:', dept.deptId, dept.deptName, 'isRegion:', dept.isRegion, 'isDealer:', dept.isDealer)
            }
            return isValid
          }

          return false
        })

        console.log('过滤后的部门数量:', filteredDepts.length)
        console.log('过滤后的部门ID:', filteredDepts.map(d => d.deptId))

        // 检查哪些目标ID没有找到
        const foundTargetIds = filteredDepts.filter(d => targetDeptIds.includes(d.deptId)).map(d => d.deptId)
        const missingIds = targetDeptIds.filter(id => !foundTargetIds.includes(id))
        if (missingIds.length > 0) {
          console.warn('未找到的目标部门ID:', missingIds)
        }

        if (filteredDepts.length === 0) {
          this.$message.warning('没有符合条件的部门数据可导出')
          return
        }

        // 递归获取部门完整路径（名称）
        const getDeptNamePath = (deptId) => {
          const dept = deptMap[deptId]
          if (!dept) return ''

          if (!dept.parentId || dept.parentId === 0) {
            return dept.deptName
          }

          const parentPath = getDeptNamePath(dept.parentId)
          return parentPath ? `${parentPath} > ${dept.deptName}` : dept.deptName
        }

        // 递归获取部门完整路径（ID）
        const getDeptIdPath = (deptId) => {
          const dept = deptMap[deptId]
          if (!dept) return ''

          if (!dept.parentId || dept.parentId === 0) {
            return String(dept.deptId)
          }

          const parentPath = getDeptIdPath(dept.parentId)
          return parentPath ? `${parentPath} > ${dept.deptId}` : String(dept.deptId)
        }

        // 准备导出数据
        const exportData = filteredDepts.map((dept, index) => ({
          '序号': index + 1,
          '部门ID': dept.deptId,
          '区域': dept.deptArea,
          '部门全称': dept.deptFullName,
          '部门名称': dept.deptName,
          '完整路径（名称）': getDeptNamePath(dept.deptId),
          '完整路径（ID）': getDeptIdPath(dept.deptId),
          '上级部门ID': dept.parentId || ''
        }))

        // 使用 XLSX 导出
        const XLSX = require('xlsx')
        const ws = XLSX.utils.json_to_sheet(exportData)

        // 设置列宽
        ws['!cols'] = [
          { wch: 8 },  // 序号
          { wch: 12 }, // 部门ID
          { wch: 25 }, // 部门名称
          { wch: 50 }, // 完整路径（名称）
          { wch: 30 }, // 完整路径（ID）
          { wch: 15 }  // 上级部门ID
        ]

        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, '部门信息')

        // 下载文件
        XLSX.writeFile(wb, `部门信息_${new Date().Format('yyyyMMddHHmmss')}.xlsx`)
        this.$message.success('导出成功')
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败，请重试')
      }
    },
    // 处理部门筛选变化（多选）
    handleDeptFilterChange(depts) {
      this.selectedDepts = depts || []
    },
    // 处理部门ID变化（由组件返回，包含子部门）
    handleDeptIdsChange(deptIds) {
      console.log('materialApplyQuota - 接收到的部门IDs:', deptIds)
      this.selectedDeptIds = deptIds || []
    },
    // 处理表单部门变化（单选）
    handleDeptFormChange(dept) {
      if (dept) {
        this.formData.deptId = dept.deptId
        this.formData.deptName = dept.deptName
      } else {
        this.formData.deptId = null
        this.formData.deptName = null
      }
    },
    // 处理年份选择（筛选条件）
    handleYearChange(value) {
      this.queryCondition.applyYear = value
      this.yearPickerOpen = false
    },
    // 处理年份选择（表单）
    handleFormYearChange(value) {
      this.formData.applyYear = value
      this.formYearPickerOpen = false
    },
    // 年份选择器打开状态改变
    handleYearOpenChange(status) {
      this.yearPickerOpen = status
    },
    // 表单年份选择器打开状态改变
    handleFormYearOpenChange(status) {
      this.formYearPickerOpen = status
    },
    // 导出
    async exportMaterialApplyQuotaList(){
      this.listLoading = true
      const queryData = {
        page: this.pagination.current,
        limit: this.pagination.size,
        applyYear: this.queryCondition.applyYear ? this.queryCondition.applyYear.format('YYYY') : null
      }
      // 添加部门筛选条件（使用组件返回的 deptIds）
      if (this.selectedDeptIds.length > 0) {
        queryData.deptIds = this.selectedDeptIds.join(',')
      }
      console.log('导出参数:', queryData)

      try {
        const val = await exportMaterialApplyQuotaList(queryData)
        // 正常导出文件
        this.$exportExcelData(val, `物料申请额度维护-${new Date().Format('yyyy年MM月DD日-HH点mm分')}.xlsx`)
        this.listLoading = false
      } catch (err) {
        console.log('导出错误:', err)
        this.$message.error('导出失败')
        this.listLoading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.a-input--medium .a-input__inner {
  height: 30px;
}
.operate {
  display: flex;
  justify-content: space-around;
}
.a-button {
  font-size: 12px;
}
.load-buttom {
  text-decoration: none;
  height: 30px;
  padding: 0 10px;
  text-align: right;
  line-height: 30px;
  color: #00a7e5;
  display: inline-block;
  font-size: 12px;
  cursor: pointer;
}
.load-buttom:hover {
  color: #00b7bf;
}
.err-box {
  margin-top: 10px;
}
</style>
